module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_dashbord_admin_remoteEntry_mjs_aa8e6508__;